<template>

<v-dialog v-model="dialog" width="700px">
  <v-card class="dummy" style="height: 500px">
    <p class=".title ma-2">Update the Google address of {{huis.huis_code}} </p>
    <v-form ref="updAddress" v-model="updAddressValid">
    <span v-if="huis.huis_oud_adres != ''" class="ma-2">Old manual address : {{huis.huis_oud_adres}}<br></span>
    <span class="ma-2">Current google City / Region / Province : {{huis.huis_google_adres}} </span><br>
        <vuetify-google-autocomplete
            id="adress"
            classname="form-control"
            v-model="googleAddress"
            placeholder="Please enter the new accommodation adress"
            v-on:placechanged="getAddressData"
            country=""
            >
        </vuetify-google-autocomplete>
    
    

    </v-form>
    <v-card-actions class="card-actions">
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updAddress" :disabled="!addressData">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

export default {
  components: {
    VuetifyGoogleAutocomplete
  },
  data() { 
    return {
      dialog: false,
      updAddressValid: false,
      huis_encrid: null,
      googleAddress: '',
      huis: {},
      addressData: null,
      placeResultData: null,
      id: null
    }
  },
  methods: {
    open(huis_encrid) {
      this.googleAddress = '';
      this.addressData = null;
      this.placeResultData = null;
      this.$axios
        .post("ares/json/ares/huis/getHuisToUpdAddress.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToUpdAddress"
          },
          getHuisToUpdAddress: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToUpdAddress;
            this.dialog = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    updAddress() { 
      this.$axios
        .post("ares/json/ares/huis/saveHuisGplc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHuisGplc"
          },
          saveHuisGplc: {
            huis_encrid: this.huis.huis_encrid,
            huis_location: this.placeResultData.geometry.location,
            gplc_id: this.placeResultData.place_id
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huis/onHuis/' + res.data.saveHuisGplc.huis_encrid);            
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHuisGplc.text,
              color: res.data.saveHuisGplc.color
            }); 
            this.dialog = false;
          }
        })
    },
    
        getAddressData(addressData, placeResultData, id) {
            this.addressData = addressData;
            this.placeResultData = placeResultData;
            this.id = id;
        }
  }
}
</script>

<style scoped>
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>

